angular.module('stack.common.api.models.CrudService', [
  'global'
])

/**
 * The CrudService service manages CRUD operations for
 * models
 *
 * @class CrudService
 * @constructor
 * @module stack.common.api.models.CrudService
 */
.factory('CrudService', [
  function () {
    'use strict';

    var service = {
      /**
       * Determines whether or not the provided model
       * has the provided crud operation available
       * for use.
       *
       * @param {string} crud - The id of the CRUD operation to check
       * @param {Object} model - Model object
       * @return {boolean} Crud exists
       */
      hasCrud: function hasCrud(crud, model) {
        return !_.isEmpty(_.find(model.crud, { id: crud }));
      },

      /**
       * Determines whether or not the provided model
       * has the provided crud operation available
       * for use.
       *
       * @param {string} crud - The id of the CRUD operation to find
       * @param {Arrays<Object>} cruds - The list of CRUDs
       * @return {Object} The CRUD associated with the input id
       */
      getCrud: function getCrud(crud, cruds) {
        return _.find(cruds, { id: crud });
      }
    };

    return service;
  }
]);
